import domain from "assets/svg/domain.svg";
import brand from "assets/svg/branding.svg";
import point from "assets/svg/conversion2.svg";

export const ACCOUNT_STORE_TYPE = "Spree::AccountStore";
export const MOMENT_STORE_TYPE = "Spree::MomentStore";
export const ESHOP_STORE_TYPE = "Spree::EshopStore";

export const APPROVAL_PENDING = "approval-pending";
export const RECIPIENT_REJECTED = "recipient-rejected";
export const ORDER_CANCELED = "canceled";

export const ORDER_STATUS = {
  live: {
    key: "live",
    label: "Live",
    colorClass: "statusLive",
  },
  redeemed: {
    key: "redeemed",
    label: "Redeemed",
    colorClass: "statusRedeemed",
  },
  expired: {
    key: "expired",
    label: "Expired",
    colorClass: "statusExpired",
  },
};

export const ORDER_SHIPMENT_STATUS = {
  packed: {
    key: "packed",
    text: "PACKED",
    iconClass: "statusShipped",
  },
  shipped: {
    key: "shipped",
    text: "SHIPPED",
    iconClass: "statusShipped",
  },
  onItsWay: {
    key: "onItsWay",
    text: "ON ITS WAY",
    iconClass: "statusShipped",
  },
  delayed: {
    key: "delayed",
    text: "DELAYED",
    iconClass: "statusRejected",
  },
  processing: {
    key: "processing",
    text: "PROCESSING",
    iconClass: "statusProcessing",
  },
  partiallyDelivered: {
    key: "partiallyDelivered",
    text: "PARTIALLY DELIVERED",
    iconClass: "statusShipped",
  },
  atSnackmagic: {
    key: "atSnackmagic",
    text: "AT SNACKMAGIC",
    iconClass: "statusPendingApproval",
  },
  inTransit: {
    key: "inTransit",
    text: "IN TRANSIT",
    iconClass: "statusInTransit",
  },
  delivered: {
    key: "delivered",
    text: "DELIVERED",
    iconClass: "statusDelivered",
  },
  externalToShip: {
    key: "externalToShip",
    text: "SHIPS FROM 3RD PARTY",
    iconClass: "statusShipped",
  },
  externalShipped: {
    key: "externalShipped",
    text: "SHIPPED FROM 3RD PARTY",
    iconClass: "statusShipped",
  },
  awaitingApproval: {
    key: "awaitingApproval",
    text: "Awaiting Approval",
    iconClass: "statusAwaitingApproval",
  },
  approvalPending: {
    key: "approvalPending",
    text: "Pending Approval",
    iconClass: "statusPendingApproval",
  },
  recipientRejected: {
    key: "recipientRejected",
    text: "Rejected",
    iconClass: "statusRejected",
  },
  canceled: {
    key: "canceled",
    text: "Canceled",
    iconClass: "statusRejected",
  },
  expired: {
    key: "expired",
    text: "Expired",
  },
  undelivered: {
    key: "undelivered",
    text: "Undelivered",
  },
  exception: {
    key: "exception",
    text: "Exception",
  },
};

export const ORDER_STATUS_FILTERS = {
  all: {
    key: "all",
    label: "All",
  },
  live: {
    key: "live",
    label: "Live",
  },
  archived: {
    key: "archived",
    label: "Archived",
  },
};

export const DEFAULT_SHOP_TAB = ORDER_STATUS_FILTERS.live.key;

export const heroBannerKey = "heroBanner";
export const logoKey = "logo";

export const LOGO_IMAGE_LABELS = {
  [heroBannerKey]: "Top Banner",
  [logoKey]: "Logo",
};

export const MENU_INTENT = "eshop";
export const ALL_PRODUCTS = "all-products";
export const PREDEFINED_MENU_ITEMS = [ALL_PRODUCTS];
export const MAX_DISPLAY_CATEGORIES_COUNT = 8;

export const USD_SHOP_CURRENCY = "USD";
export const USD_SHOP_CURRENCY_NAME = "US Dollars";
export const POINT_SHOP_CURRENCY = "STC";
export const POINT_CURRENCY_OBJ = {
  id: POINT_SHOP_CURRENCY,
  currencyKey: POINT_SHOP_CURRENCY,
  name: "Points",
  symbol: "Pts",
};
export const SHOP_CREATION_ACCEPTED_CURRENCY = [POINT_SHOP_CURRENCY, USD_SHOP_CURRENCY];
export const isCurrencyAcceptable = (currencyCode) =>
  SHOP_CREATION_ACCEPTED_CURRENCY.includes(currencyCode);

export const STORE_INFO_KEY = "store_info";
export const PAYMENT_INFO_KEY = "payment_info";

export const ORDER_ABOUT_TOOLTIP_CONTENT = {
  approvalPending: {
    key: "approvalPending",
    title: "Pending Approval",
    text: "Once the sender approves this order, your items will be shipped.",
  },
  recipientRejected: {
    key: "recipientRejected",
    title: "Points Rejected",
    text: "Your recent order was not approved by the sender.",
  },
};
export const MENU_CUSTOMIZABLE_SHOP_TEMPLATE_TYPE = "user_specific";

export const CUSTOM_DOMAIN_CUSTOMIZATION = "customDomain";
export const WHITELABEL_CUSTOMIZATION = "whitelabel";
export const CUSTOM_POINT_CONVERSION_CUSTOMIZATION = "customPointConversion";

export const SUBSCRIPTION_PACKAGES_OPTIONS = [
  {
    key: CUSTOM_DOMAIN_CUSTOMIZATION,
    label: "Custom Domain",
    description: "Replace bystadium.com with your own domain.",
    banner: domain,
    isInfoRequired: false,
  },
  {
    key: WHITELABEL_CUSTOMIZATION,
    label: "Remove Stadium branding",
    description:
      "Remove Stadium branding from the shop navigation, recipient landing page, and footer.",
    subscribedDescription:
      "Stadium branding has been removed from the shop navigation, recipient landing page, and footer.",
    banner: brand,
    isInfoRequired: true,
  },
  {
    key: CUSTOM_POINT_CONVERSION_CUSTOMIZATION,
    label: "Custom Point Conversion",
    description: "Set your shop's currency and conversion to replace Stadium Points.",
    subscribedDescription:
      "Set your shop's currency and conversion. This setting cannot be changed after you place your first order.",
    banner: point,
    isInfoRequired: false,
  },
];

export const KIT_SHOP_TYPE = "bundle";
export const SWAG_SHOP_TYPE = "swag_shop";
